<template>
<section class="py-3">
  <div class="container">
    <div class="row">
      <!-- <div class="col-sm-12 py-3">
        <h6 class="m-0 text-blue">OFFERTE - WOONPLAATS - Mr &amp; Mw …………………</h6>
      </div> -->
      <h1>Gepersonaliseerde offerte</h1>
      <div class="col-sm-12">
        <div class="alert alert-secondary p-2 mb-2 rounded-0" role="alert">
          <h6 class="m-0">1. GEGEVENS APPARTEMENT(EN)</h6>
        </div>
        <table class="table table-sm table-bordered">
          <colgroup><col width="25%">
          <col width="25%">
          <col width="25%">
          <col width="25%">
          </colgroup><tbody><tr>
            <td>Regio</td>
            <td><input type="text" class="form-control form-control-sm input-theme" name="" value="Nordrhein-Westfalen"></td>
            <td>Stad</td>
            <td><input type="text" class="form-control form-control-sm input-theme" name="" value="Gelsenkirchen"></td>
          </tr>
          <tr>
            <td>adres</td>
            <td><input type="text" class="form-control-sm form-control-plaintext text-left" value="-" readonly=""></td>
            <td>Type Residentie</td>
            <td><input type="text" class="form-control form-control-sm input-theme" name="" value="Appartement vr permanent verblijf"></td>
          </tr>
          <tr>
            <td>Beschikbaar</td>
            <td><input type="text" class="form-control-sm form-control-plaintext text-left" value="-" readonly=""></td>
            <td>Type unit / lotnr.</td>
            <td><input type="text" class="form-control-sm form-control-plaintext text-left" value="-" readonly=""></td>
          </tr>
          <tr>
            <td>Oppervlakte</td>
            <td><input type="text" class="form-control-sm form-control-plaintext text-left" value="-" readonly=""></td>
            <td>Verdieping</td>
            <td><input type="text" class="form-control-sm form-control-plaintext text-left" value="-" readonly=""></td>
          </tr>
          <tr>
            <td>Verkoopprijs</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control form-control-sm input-theme text-right" id="D15" value="1.000.000" onkeyup="$.fn.gege()">
                <input type="text" class="form-hide" id="D15hide">
                <span>€</span>
              </div>
            </td>
            <td>Jaarklijkse huur</td>
            <td>
              <div class="input-group input-group-sm">
                <input type="text" class="form-control-sm form-control-plaintext rounded-0" id="G15show" value="" readonly="">
                <input type="hidden" class="form-control-sm form-control-plaintext rounded-0" id="G15" value="6.333339666666678e+21" readonly="">
                <div class="input-group-append">
                  <span class="input-group-text rounded-0 border-0">€</span>
                  <span class="input-group-text rounded-0 px-3 bg-pink border-0" id="I15">5.70%</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody></table>
      </div>

      <!-- //2 -->
      <div class="col-sm-12 mt-3">
        <table class="table table-sm table-bordered">
          <colgroup><col width="35%">
          <col width="15%">
          <col width="25%">
          <col width="25%">
          </colgroup><tbody><tr class="table-bg">
            <th colspan="2">
              2. OVERZICHT INVESTERING
            </th>
            <td>MET KREDIET</td>
            <td>GEEN KREDIET</td>
          </tr>
          <tr>
            <td colspan="2">Aankoopprijs</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G19" value="00.00" readonly="">
                <input type="text" class="form-hide" id="G19hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I19" value="00.00" readonly="">
                <input type="text" class="form-hide" id="I19hide" value="00.00" readonly="">
                <span>€</span>
              </div></td>
          </tr>
          <tr>
            <td>(a) Notariskosten incl. Overdrachtsbelasting</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control form-control-sm input-theme text-right" id="F20" onkeyup="$.fn.ovin()" value="9,50">
                <input type="text" class="form-hide" id="F20hide" value="9.50">
                <span>%</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G20" value="00.00" readonly="">
                <input type="text" class="form-hide" id="G20hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I20" value="00.00" readonly="">
                <input type="text" class="form-hide" id="I20hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>(c) Begeleidingsvergoeding (incl. BTW)</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control form-control-sm input-theme text-right" id="F21" onkeyup="$.fn.ovin()" value="3,00">
                <input type="text" class="form-hide" id="F21hide" value="3.00">
                <span>%</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G21" value="00.00" readonly="">
                <input type="text" class="form-hide" id="G21hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I21" value="00.00" readonly="">
                <input type="text" class="form-hide" id="I21hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr class="table-graybg">
            <th>TOTALE INVESTERING</th>
            <td>Bruto</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G23" value="00.00" readonly="">
                <input type="text" class="form-hide" id="G23hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I23" value="00.00" readonly="">
                <input type="text" class="form-hide" id="I23hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
        </tbody></table>
      </div>

      <!-- 3 -->
      <div class="col-sm-12 mt-3">
        <div class="alert alert-secondary p-2 mb-2 rounded-0" role="alert">
          <h6 class="m-0">3. PARAMETERS KLANT</h6>
        </div>
        <table class="table table-sm table-bordered">
          <colgroup><col width="35%">
          <col width="15%">
          <col width="25%">
          <col width="25%">
          </colgroup><tbody><tr class="table-bg">
            <th>EIGEN INBRENG</th>
            <th class="text-right text-warning">(§)</th>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G26" value="00.100" readonly="">
                <input type="text" class="form-hide" id="G26hide" value="" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I26" value="00.00" readonly="">
                <input type="text" class="form-hide" id="I26hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>Eigen inbreng in pand</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="F28" value="17,68" readonly="">
                <input type="text" class="form-hide" id="F28hide" value="17.68" readonly="">
                <span>%</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G28" value="00.00" readonly="">
                <input type="text" class="form-hide" id="G28hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I28" value="00.00" readonly="">
                <input type="text" class="form-hide" id="I28hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>Eigen inbreng voor kosten (a) + (b) + (c)</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="F29" value="11,61" readonly="">
                <input type="text" class="form-hide" id="F29hide" value="11.61" readonly="">
                <span>%</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G29" value="00.00" readonly="">
                <input type="text" class="form-hide" id="G29hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I29" value="00.00" readonly="">
                <input type="text" class="form-hide" id="I29hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>Bancair krediet</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="F30" value="70,72" readonly="">
                <input type="text" class="form-hide" id="F30hide" value="70.72" readonly="">
                <span>%</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G30" value="00.00" readonly="">
                <input type="text" class="form-hide" id="G30hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I30" value="00.00" readonly="">
                <input type="text" class="form-hide" id="I30hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
        </tbody></table>
      </div>

      <!-- 4 -->
      <div class="col-sm-12 mt-3">
        <div class="alert alert-secondary p-2 mb-2 rounded-0" role="alert">
          <h6 class="m-0">4. HUURINKOMSTEN</h6>
        </div>
        <table class="table table-sm table-bordered">
          <colgroup><col width="50%">
          <col width="25%">
          <col width="25%">
          </colgroup><tbody><tr>
            <td>JAARLIJKSE HUUR</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G34" value="00.00" readonly="">
                <input type="text" class="form-hide" id="G34hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I34" value="00.00" readonly="">
                <input type="text" class="form-hide" id="I34hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>MAANDELIJKSE HUUR</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G35" value="00.00" readonly="">
                <input type="text" class="form-hide" id="G35hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I35" value="00.00" readonly="">
                <input type="text" class="form-hide" id="I35hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>BRUTO INCL. AANKOOPKOSTEN</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G36" value="00.00" readonly="">
                <input type="text" class="form-hide" id="G36hide" value="00.00" readonly="">
                <span>%</span>
              </div>
            </td>
            <td>
              <div class="input-wrap bg-pink">
                <input type="text" class="form-control-sm form-control-plaintext" id="I36" value="00.00" readonly="">
                <input type="text" class="form-hide" id="I36hide" value="00.00" readonly="">
                <span>%</span>
              </div>
            </td>
          </tr>
        </tbody></table>
      </div>

      <!-- 5 -->
      <div class="col-sm-12 mt-3">
        <div class="alert alert-secondary p-2 mb-2 rounded-0" role="alert">
          <h6 class="m-0">5. JAARLIJKSE AFTREKBARE KOSTEN</h6>
        </div>
        <table class="table table-sm table-bordered">
          <colgroup><col width="20%">
          <col width="30%">
          <col width="25%">
          <col width="25%">
          </colgroup><tbody><tr>
            <td rowspan="4">Kosten</td>
            <td>Lasten mede-eigendom</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G40" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G40hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I40" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I40hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>Beheersmandaat</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G41" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G41hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I41" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I41hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>Grondbelasting</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G42" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G42hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I42" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I42hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>Boekhouder</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control form-control-sm input-theme text-right" id="G43" onkeyup="$.fn.jako()" value="107,00">
                <input type="text" class="form-hide" id="G43hide" value="107.00">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I43" value="00.00" readonly="">
                <input type="text" class="form-hide" id="I43hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td rowspan="3">Minderingen</td>
            <td>Afschrijvingen</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G44" value="00.00" readonly="">
                <input type="text" class="form-hide" id="G44hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I44" value="00.00" readonly="">
                <input type="text" class="form-hide" id="I44hide" value="00.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>Forfait (algemene onkosten)</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control form-control-sm input-theme text-right" id="G45" onkeyup="$.fn.jako()" value="150,00">
                <input type="text" class="form-hide" id="G45hide" onkeyup="$.fn.jako()" value="150.00">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I45" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I45hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>Intresten <em class="text-success">(1ste jaar)</em></td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G46" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G46hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I46" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I46hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr class="table-graybg">
            <th colspan="2">Total</th>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G47" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G47hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I47" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I47hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
        </tbody></table>
      </div>

      <!-- 6 -->
      <div class="col-sm-12 mt-3">
        <div class="alert alert-secondary p-2 mb-2 rounded-0" role="alert">
          <h6 class="m-0">6. BELASTINGEN <small>(JAAR 1)</small></h6>
        </div>
        <table class="table table-sm table-bordered">
          <colgroup><col width="20%">
          <col width="15%">
          <col width="15%">
          <col width="25%">
          <col width="25%">
          </colgroup><tbody><tr>
            <td>Jaarhuur</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="D51" value="0.00" readonly="">
                <input type="text" class="form-hide" id="D51hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>Belastbare basis</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G51" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G51hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I51" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I51hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="3">Belastingen voor inkomsten 2018</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G52" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G52hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I52" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I52hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="3">Belastingen in % van de brutohuur</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G53" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G53hide" value="0.00" readonly="">
                <span>%</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I53" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I53hide" value="0.00" readonly="">
                <span>%</span>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="3">Netto jaarinkomen (zonder rekening met leninglast)</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G54" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G54hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I54" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I54hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="3">Netto maandhuur</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G55" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G55hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I55" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I55hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="3">Netto huurrendement</td>
            <td>
              <div class="input-wrap bg-pink">
                <input type="text" class="form-control-sm form-control-plaintext" id="G56" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G56hide" value="0.00" readonly="">
                <span>%</span>
              </div>
            </td>
            <td>
              <div class="input-wrap bg-pink">
                <input type="text" class="form-control-sm form-control-plaintext" id="I56" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I56hide" value="0.00" readonly="">
                <span>%</span>
              </div>
            </td>
          </tr>
        </tbody></table>
      </div>

      <!-- 7 -->
      <div class="col-sm-12 mt-3">
        <div class="alert alert-secondary p-2 mb-2 rounded-0" role="alert">
          <h6 class="m-0">7. AFLOSSING INTRESTEN EN KAPITAAL
          	<small class="float-right">*) Maximale ontleencapaciteit ≤ 33% nettoloon</small>
          </h6>
        </div>
        <table class="table table-sm table-bordered">
          <colgroup><col width="35%">
          <col width="15%">
          <col width="25%">
          <col width="25%">
          </colgroup><tbody><tr>
            <td>Kost voor krediet op 10 jaar - %</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control form-control-sm input-theme text-right" id="F60" onkeyup="$.fn.gege()" value="1,70">
                <input type="text" class="form-hide" id="F60hide" onkeyup="$.fn.gege()" value="1.70">
                <span>%</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G60" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G60hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I60" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I60hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>Kost voor krediet op 15 jaar - %</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control form-control-sm input-theme text-right" id="F61" onkeyup="$.fn.gege()" value="1,90">
                <input type="text" class="form-hide" id="F61hide" onkeyup="$.fn.gege()" value="1.90">
                <span>%</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G61" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G61hide" value="0.00" readonly="">
                <span>€</span>
              </div></td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I61" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I61hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>Kost voor krediet op 20 jaar - %</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control form-control-sm input-theme text-right" id="F62" onkeyup="$.fn.gege()" value="2,10">
                <input type="text" class="form-hide" id="F62hide" onkeyup="$.fn.gege()" value="2.10">
                <span>%</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G62" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G62hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I62" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I62hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
        </tbody></table>
      </div>

      <!-- 8 -->
      <div class="col-sm-12 mt-3">
        <div class="alert alert-secondary p-2 mb-2 rounded-0" role="alert">
          <h6 class="m-0">8. Maandelijkse SPAARINSPANNING <span class="text-danger">(rood)</span> / OVERSCHOT <span class="text-green">(groen)</span> - gemiddeld over duur van krediet
          </h6>
        </div>
        <table class="table table-sm table-bordered">
          <colgroup><col width="50%">
          <col width="25%">
          <col width="25%">
          </colgroup><tbody><tr>
            <td>op basis van krediet op 10 JAAR</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G66" data-posneg="-406217422035371884544.00" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G66hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I66" data-posneg="372378150155556225024.00" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I66hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>op basis van krediet op 15 JAAR</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G67" data-posneg="-164424003290457899008.00" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G67hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I67" data-posneg="372378150155556225024.00" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I67hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>op basis van krediet op 20 JAAR</td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G68" data-posneg="-46293079737197199360.00" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G68hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I68" data-posneg="372378150155556225024.00" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I68hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
        </tbody></table>
      </div>


      <!-- 9 -->
      <div class="col-sm-12 mt-3">
        <div class="alert alert-secondary p-2 mb-2 rounded-0" role="alert">
          <h6 class="m-0">9. RENTABILITEIT VAN HET PROJECT</h6>
        </div>
        <table class="table table-sm table-bordered">
          <colgroup><col width="35%">
          <col width="15%">
          <col width="25%">
          <col width="25%">
          </colgroup><tbody><tr>
            <td>Projectie op</td>
            <td>
              <input type="text" class="form-control form-control-sm input-theme text-right" id="F72" onkeyup="$.fn.gege()" value="10">
              <input type="text" class="form-hide" id="F72hide" onkeyup="$.fn.gege()" value="10">
            </td>
            <td colspan="2">jaar (*)</td>
          </tr>
          <tr>
          	<td colspan="2">Huurinkomsten na belastingen</td>
          	<td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G74" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G74hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I74" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I74hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
          	<td>Geprojecteerde meerwaarde per jaar (%)</td>
          	<td>
              <div class="input-wrap">
                <input type="text" class="form-control form-control-sm input-theme text-right" id="F75" onkeyup="$.fn.gege()" value="2,0">
                <input type="text" class="form-hide" id="F75hide" onkeyup="$.fn.gege()" value="2.0">
              </div>
            </td>
          	<td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G75" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G75hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I75" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I75hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
          	<td colspan="2" class="text-right">(*) Geen meerwaardebelasting</td>
          	<td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G76" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G76hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I76" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I76hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr class="table-graybg">
            <td colspan="4"></td>
          </tr>
          <tr>
          	<td colspan="2">Aankoopkosten</td>
          	<td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G78" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G78hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I78" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I78hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
          	<td colspan="2">Intresten</td>
          	<td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G79" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G79hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I79" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I79hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2"></td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G80" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G80hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I80" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I80hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
          <tr class="table-graybg">
            <td colspan="4"></td>
          </tr>
          <tr>
          	<td colspan="2">Geraamde netto opbrengst van het totale project</td>
          	<td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="G82" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G82hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
            <td>
              <div class="input-wrap">
                <input type="text" class="form-control-sm form-control-plaintext" id="I82" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I82hide" value="0.00" readonly="">
                <span>€</span>
              </div>
            </td>
          </tr>
        </tbody></table>
      </div>


      <!-- 10 -->
      <div class="col-sm-12 mt-3">
        <div class="alert alert-secondary p-2 mb-2 rounded-0" role="alert">
          <h6 class="m-0">10. RENTABILITEIT OP EIGEN INBRENG (ROI) <strong class="text-warning">(§)</strong></h6>
        </div>
        <table class="table table-sm table-bordered">
          <colgroup><col width="50%">
          <col width="25%">
          <col width="25%">
          </colgroup><tbody><tr>
            <td>10 JAAR</td>
            <td>
              <div class="input-wrap bg-pink">
                <input type="text" class="form-control-sm form-control-plaintext" id="G86" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G86hide" value="0.00" readonly="">
                <span>%</span>
              </div>
            </td>
            <td>
              <div class="input-wrap bg-pink">
                <input type="text" class="form-control-sm form-control-plaintext" id="I86" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I86hide" value="0.00" readonly="">
                <span>%</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>15 JAAR</td>
            <td>
              <div class="input-wrap bg-pink">
                <input type="text" class="form-control-sm form-control-plaintext" id="G87" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G87hide" value="0.00" readonly="">
                <span>%</span>
              </div>
            </td>
            <td>
              <div class="input-wrap bg-pink">
                <input type="text" class="form-control-sm form-control-plaintext" id="I87" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I87hide" value="0.00" readonly="">
                <span>%</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>20 JAAR</td>
            <td>
              <div class="input-wrap bg-pink">
                <input type="text" class="form-control-sm form-control-plaintext" id="G88" value="0.00" readonly="">
                <input type="text" class="form-hide" id="G88hide" value="0.00" readonly="">
                <span>%</span>
              </div>
            </td>
            <td>
              <div class="input-wrap bg-pink">
                <input type="text" class="form-control-sm form-control-plaintext" id="I88" value="0.00" readonly="">
                <input type="text" class="form-hide" id="I88hide" value="0.00" readonly="">
                <span>%</span>
              </div>
            </td>
          </tr>
        </tbody></table>
      </div>


      <!-- 9 -->
      <div class="col-sm-12 mt-3">
      	<p class="mb-1">
      		*Onze berekeningen houden geen rekening met uw belastingaangifte in België.
      	</p>
      	<p>
      		*Ondanks alle inspanningen kan Rendimmo bvba niet garanderen dat de informatie in deze simulatie actueel, juist en volledig is. Rendimmo bvba is niet verantwoordelijk voor de informatie in deze simulatie en kan niet aansprakelijk gesteld worden voor eventuele nadelige gevolgen van eventuele onjuistheid of onvolledigheid van de gegevens.
      		<br>
      		De relevantie, de actualiteit, de juistheid en de volledigheid kan evenmin door Rendimmo bvba gegarandeerd worden en Rendimmo bvba kan evenmin aansprakelijk gesteld worden voor eventuele nadelige gevolgen van eventuele irrelevantie, onjuistheid of onvolledigheid van het bedoelde externe informatiemateriaal.<br>
      		Aan deze gegevens kunnen geen rechten ontleend worden."
      	</p>
      </div>

    </div>
  </div>
</section>

</template>

<script>
import calcInit from './calculations'
export default {
  name: 'CalculatorIndex',
  components: {},

  mounted () {
    // setTimeout(() => calcInit(), 1000)
    calcInit();
  }
}
</script>

<style lang="scss" scoped>

$color-theme: lighten(#4caf50, 30%);
$color-theme: #61b06c;

$font-color: white;
$input-font-color: black;

.form-hide {
  display: none;
}
.container{
	width: 100%;
	max-width: 1200px;
}
.l{
	box-shadow: inset 0 0 2px red, 0 0 2px blue;
}

.bg-theme, .table-bg{
	background-color: $color-theme !important;
  input, span, td {
	  color: $font-color !important;
  }
}

.alert-secondary {
  color: $font-color;
  background-color: $color-theme;
  border-color: $color-theme;
  border-left-width: 4px;
  border-left-color: #95c93d;
}

.table-bordered td, .table-bordered th {
  border: 1px solid $color-theme;
  vertical-align: middle;
  color: #555;
	// color: $font-color !important;
}

.text-green{
	color: #94C93D;
}
.text-blue{
	color: black;
}

.input-wrap{
	position: relative;
}
.input-wrap span{
	color: #444;
	background: transparent;
	position: absolute;
	right: 5px;
	top: 0;
	font-size: 14px;
	height: 30px;
	line-height: 32px;
	user-select: none;
	pointer-events: none;
}
.input-wrap .input-theme ~ span{
	color: $input-font-color;
	font-weight: 600;
	font-style: italic;
	right: 8px;
}
.input-theme{
	color: $input-font-color;
	font-weight: 600;
	border-radius: 0;
	font-style: italic;
  background-color: lighten(#61b06c, 30%) !important;
  padding-right: 25px !important;
  height: 32px !important;
  border-left-width: 4px !important;
  border-left-color: #61b06c !important;
}
.input-wrap input[readonly]{
  padding-right: 18px;
  height: 32px !important;
  border: 1px solid #ddd !important;
}
.table-graybg{
	background-color: #eee;
  th {
    color: #555 !important;
  }

}
.table-bordered [readonly]{
	text-align: right;
}
.mt-3 {
  margin-top: 50px;
}
td input[readonly] {
  height: 32px !important;
  width: 100%;
  background: none;
  text-align: left !important;
  border: none !important;
}
th {
  color: $font-color !important;
}
small {
  color: silver !important;
}
.input-group {
  display: flex !important;
  align-items: center;
}
.input-group-append {
  background-color: #cc3399;
  padding: 5px;
  color: white !important;
}
</style>
